import { render, staticRenderFns } from "./FilterTags.vue?vue&type=template&id=59d11428&scoped=true"
import script from "./FilterTags.vue?vue&type=script&lang=js"
export * from "./FilterTags.vue?vue&type=script&lang=js"
import style0 from "./FilterTags.vue?vue&type=style&index=0&id=59d11428&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d11428",
  null
  
)

export default component.exports